export const packageConst = {
  appName: '@epihub/core',
  appVersion: '1.0.0',
};
